import React from "react";
import cn from "classnames";
import styles from "./Item.module.sass";
import { Link, useNavigate } from "react-router-dom";
import { markNotificationAsRead } from "../../../../services/notification.service";
import { getCompanyById } from "../../../../services/company.service";
import Checkbox from "../../../../components/Checkbox";

const formatTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);

  let interval = seconds / 31536000;
  if (interval > 1) return `${Math.floor(interval)}a`;
  interval = seconds / 2592000;
  if (interval > 1) return `${Math.floor(interval)}m`;
  interval = seconds / 86400;
  if (interval > 1) return `${Math.floor(interval)}j`;
  interval = seconds / 3600;
  if (interval > 1) return `${Math.floor(interval)}h`;
  interval = seconds / 60;
  if (interval > 1) return `${Math.floor(interval)}m`;
  return `${Math.floor(seconds)}s`;
};

const Item = ({ className, item, onClose, selected, onSelect }) => {
  const navigate = useNavigate();
  const imagePath = `/images/content/${item.icon}`;

  const handleClick = async (e) => {
    // Empêcher le comportement par défaut pour gérer la navigation manuellement
    if (e) {
      e.preventDefault();
    }

    console.log('Notification cliquée:', {
      id: item.id,
      title: item.title,
      link: item.link,
      read: item.read
    });

    // Marquer la notification comme lue si ce n'est pas déjà fait
    if (!item.read) {
      try {
        await markNotificationAsRead(item.id);
        console.log('Notification marquée comme lue');
      } catch (error) {
        console.error('Erreur lors du marquage de la notification comme lue:', error);
      }
    }

    // Fermer le menu de notifications si nécessaire
    if (onClose) {
      onClose();
      console.log('Menu de notifications fermé');
    }

    // Naviguer vers le lien après avoir marqué comme lu et fermé le menu
    if (item.link) {
      console.log('Navigation vers:', item.link);
      
      // Vérifier si le lien est valide
      if (item.link.startsWith('/admin/companies/')) {
        // Pour les liens d'entreprises, récupérer d'abord les données comme le fait CompanyList/Row
        try {
          const companyId = item.link.split('/admin/companies/')[1];
          console.log('Récupération des données de l\'entreprise:', companyId);
          
          const companyData = await getCompanyById(companyId);
          if (companyData) {
            navigate(item.link, { state: { company: companyData } });
            console.log('Navigation admin réussie avec données entreprise vers:', item.link);
          } else {
            // Si pas de données, naviguer quand même mais sans state
            navigate(item.link, { replace: true });
            console.log('Navigation admin sans données vers:', item.link);
          }
        } catch (error) {
          console.error('Erreur lors de la récupération des données entreprise:', error);
          // Fallback: naviguer sans les données
          navigate(item.link, { replace: true });
        }
      } else if (item.link.startsWith('/admin/')) {
        // Pour les autres liens admin, utiliser une navigation directe
        try {
          navigate(item.link, { replace: true });
          console.log('Navigation admin réussie vers:', item.link);
        } catch (error) {
          console.error('Erreur lors de la navigation admin:', error);
          // Fallback: essayer avec window.location
          window.location.href = item.link;
        }
      } else {
        // Pour les autres liens, utiliser la navigation normale
        setTimeout(() => {
          navigate(item.link);
        }, 50);
      }
    } else {
      console.warn('Aucun lien défini pour cette notification');
    }
  };

  const content = (
    <div className={cn(styles.item, { [styles.new]: !item.read }, className)}>
      <div className={styles.checkbox} onClick={(e) => e.stopPropagation()}>
        <Checkbox
          value={selected}
          onChange={() => onSelect && onSelect(item.id)}
        />
      </div>
      <div className={styles.avatar}>
        <img src={imagePath} alt={item.title} />
      </div>
      <div className={styles.details}>
        <div className={styles.line}>
          <div className={styles.subtitle}>{item.title}</div>
          <div className={styles.time}>{formatTime(item.created)}</div>
        </div>
        <div className={styles.content}>
          {item.message}
        </div>
      </div>
    </div>
  );

  // Utiliser un div cliquable dans tous les cas pour éviter les conflits entre Link et navigate
  return (
    <div onClick={handleClick} style={{ cursor: 'pointer' }}>
      {content}
    </div>
  );
};

export default Item;
